import { useEffect } from "react";
import { Icon } from "@iconify/react";
import {
  Box,
  HStack,
  isCompanySettingsReadOnly,
  VStack,
} from "../../components/utils";
import { useGetAllCorporateActions } from "../../queries/onBoarding";
import { useCompanyStore, usePermissionStore } from "../../store";
import CorporateActionDetailsCard from "./CorporateActionDetailsCard";
import { CorporateActionDetails } from "../../types/CompanyProfile";
import DropdownButton from "../../components/shared/DropdownButton";
import { Action } from "../../components/shared/Dropdown";
import { determineUserAccessToResource } from "../../utils/auth";
import {
  Action as DefaultAction,
  Resource,
} from "../../utils/interfaces/Companies";

function AllCorporateActionDetails({
  corporateActions,
  handleCorporateAction,
  openBonusDialog,
  openSplitDialog,
  openBonusRatioChangeDialog,
}: {
  corporateActions?: CorporateActionDetails[];
  handleCorporateAction: (action: Action) => void;
  openBonusDialog: Function;
  openSplitDialog: Function;
  openBonusRatioChangeDialog: Function;
}) {
  const { permission } = usePermissionStore();
  const isUserReadOnly = isCompanySettingsReadOnly();

  return (
    <Box className="w-full bg-white rounded-md">
      <Box className="">
        <VStack className="justify-between">
          <Box className="border-b px-10 py-4 font-medium text-left">
            <HStack className="justify-between">
              <h6 className="text-lg">Corporate Actions</h6>
              <DropdownButton
                className="items-center"
                actions={[
                  {
                    name: "Add Bonus",
                    disabled:
                      !determineUserAccessToResource(
                        permission?.aclList || [],
                        Resource.All,
                        DefaultAction.Edit
                      ) || isUserReadOnly,
                  },
                  {
                    name: "Add Split",
                    disabled:
                      !determineUserAccessToResource(
                        permission?.aclList || [],
                        Resource.All,
                        DefaultAction.Edit
                      ) || isUserReadOnly,
                  },
                ]}
                onAction={handleCorporateAction}
                render={() => (
                  <div className="flex items-center rounded">
                    <p>Corporate Actions</p>
                    <Icon
                      height={24}
                      icon="ri:arrow-drop-down-line"
                      className="inline"
                    />
                  </div>
                )}
                subtitle="Corporate Actions"
              />
            </HStack>
          </Box>
          <VStack className="p-8 px-15 py-4 gap-4">
            {corporateActions?.map((corporateAction) => (
              <div key={corporateAction.id}>
                <CorporateActionDetailsCard
                  corporateAction={corporateAction}
                  openBonusDialog={openBonusDialog}
                  openSplitDialog={openSplitDialog}
                  openBonusRatioChangeDialog={openBonusRatioChangeDialog}
                />
              </div>
            ))}
          </VStack>
        </VStack>
      </Box>
    </Box>
  );
}

export default AllCorporateActionDetails;
